import React from 'react';
import classNames from 'classnames';
import AlertHeading from '../Alert/AlertHeading';
import AlertText from '../Alert/AlertText';

export interface SiteAlertProps {
  children?: React.ReactNode;
  className?: string;
  id?: string;
  status: 'info' | 'emergency';
  label: string;
  noIcon?: boolean;
  slim?: boolean;
}

const SiteAlert = ({ className, status, children, noIcon, slim, id, label }: SiteAlertProps): JSX.Element => {
  const alertClasses = classNames(className, {
    'usa-site-alert': true,
    [`usa-site-alert--${status}`]: true,
    'usa-site-alert--slim': slim,
    'usa-site-alert--no-icon': noIcon,
  });

  return (
    <section id={id} className={alertClasses} aria-label={label}>
      <div className="usa-alert">
        <div className="usa-alert__body">{children}</div>
      </div>
    </section>
  );
};

SiteAlert.Heading = AlertHeading;
SiteAlert.Text = AlertText;

export default SiteAlert;
